/**
 * Whether a product holds stock of its own (CHG-2026-09-stock-usage-and-price-twins, D11).
 *
 * A dish takes its stock from its parts, a variant from its source, and a not-tracked article
 * holds none at all: receipts, corrections, transfers and deliveries naming one are refused by the
 * server with `product_has_no_stock`, so the backoffice does not offer them.
 */
export type NoStockReason = 'dish' | 'variant' | 'not_tracked'

export interface StockModeFields {
  isDish?: boolean
  variantSourceSku?: string
  stockTracked?: boolean
  /** The derived-reading kind some endpoints send instead of the three fields above. */
  stockKind?: 'article' | NoStockReason
}

/** Null for an ordinary stock article — including a payload that predates the change. */
export function noStockReason(product: StockModeFields): NoStockReason | null {
  if (product.stockKind && product.stockKind !== 'article') {
    return product.stockKind
  }
  if (product.isDish) return 'dish'
  if (product.variantSourceSku) return 'variant'
  if (product.stockTracked === false) return 'not_tracked'
  return null
}
